var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.rootFieldModels),function(field){return _c('dynamic-field',{key:field.id,ref:"fields",refInFor:true,attrs:{"field":field,"field-models":_vm.fieldSetModel.fields,"value":_vm.value},on:{"input":function($event){return _vm.updateModel($event)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }